// Garantisce che le webview (app Shoppy/Mumble) abbiano la classe `webview` già pronta.
// Ricontrolla SEMPRE lo User-Agent: non si fida di un eventuale flag già impostato a `false`
// nel <head> (lo UA potrebbe arrivare dopo il parsing dell'head, es. WebView dell'editoriale).
(function() {
  var keys = ['mumble-app', 'shoppy'];
  var ua = navigator.userAgent ? navigator.userAgent.toLowerCase() : '';
  var isWebview = window.__themeIsWebview === true || keys.some(function (key) {
    return ua.indexOf(key) !== -1;
  });

  window.__themeIsWebview = isWebview;
  if (!isWebview) return;

  if (!document.documentElement.classList.contains('webview')) {
    document.documentElement.classList.add('webview');
  }

  if (document.body) {
    document.body.classList.add('webview');
  } else {
    document.addEventListener('DOMContentLoaded', function() {
      document.body.classList.add('webview');
    });
  }
})();
